import React from 'react';
import Stack from '@mui/material/Stack';
import { Typography } from '../../../Typography';
import { colorPalette } from '../../../../colorPalette';
export const StepComponent = ({ stepSvg, title, subtitle }) => {
    return (React.createElement(Stack, { direction: "row", alignItems: "center", justifyContent: "center", spacing: "16px" },
        React.createElement("div", null, stepSvg),
        React.createElement(Stack, { alignItems: "flex-start", padding: "0px" },
            React.createElement(Typography, { variant: "h4-semibold", color: colorPalette.gray900, sx: { display: 'flex', alignItems: 'center' } }, title),
            React.createElement(Typography, { variant: "h4-regular", color: colorPalette.gray600, sx: { flexWrap: 'wrap', display: 'flex', alignItems: 'center' } }, subtitle))));
};
